import { makeAutoObservable, runInAction } from 'mobx';

import {
  frontApi,
  API_ROUTES
} from '_app/api';
// import toast from 'utils/toast';

export class PostsStore {
  constructor() {
    makeAutoObservable(this);
  }

  isLoading = false;

  data = [];

  errors = {};

  fetchData = async () => {
    try {
      const { data } = await frontApi(API_ROUTES.posts);

      runInAction(() => {
        this.data = data;
      });

    } catch (error) {
      console.error(error);
    }
  };
}

export default new PostsStore();
